import { TOGGLE_ALL_POSTBASES } from './actionTypes';

export const toggleAllPostbases = () => ({
  type: TOGGLE_ALL_POSTBASES,
  payload: {}
});



// WEBPACK FOOTER //
// ./src/redux/actions.js